import React from "react";

class Giveaway extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        {" "}
        <h1>COMING SOON</h1>
      </div>
      /*<iframe
        src="https://woorise.com/destiny/nft-giveaway"
        style={{
          flexGrow: "1",
          border: "none",
          padding: "0",
          marginTop: "-70px",
          borderRadius: "10px",
          height: "777px",
          minHeight: "100%",
          width: "100",
          overflow: "hidden",
        }}
      ></iframe>*/
    );
  }
}

Giveaway.displayName = "Giveaway";

export default Giveaway;
